<template>
    <div class="help-view">
        <heading :title="title" key="help-view-title"/>
        <b-row>
            <b-col class="col-12">
                <view-table
                    :model="help"
                    :data="helpInfo"
                    :fields="['tag', 'content']"/>
            </b-col>
        </b-row>
        <b-row class="mx-1 my-4">
            <b-button
                v-if="canEdit"
                variant="primary"
                :to="`/help/edit/${helpId}`">
                Edit Help Message
            </b-button>
            <b-button
                v-if="canDelete"
                class="ml-4"
                variant="danger"
                @click="deleteHelp()">
                Delete Help Message
            </b-button>
        </b-row>
    </div>
</template>

<script>
import Vue from 'vue'
import Help from '@/models/Help'
import Authorization from '@/providers/Authorization'

export default Vue.extend({
    name: 'HelpView',
    props: {
        helpId: Number,
    },
    data () {
        return {
            title: '',
            helpInfo: {},
            help: Help,
            canEdit: false,
            canDelete: false,
        }
    },
    methods: {
        deleteHelp: function (item) {
            if (this.canDelete) {
                this.$bvModal.msgBoxConfirm('Would you like to delete this help message? This action cannot be undone.')
                    .then(async (value) => {
                        if (value) {
                            this.$api.deleteItem(this, 'help', this.helpInfo)
                            this.$toasted.info('Help message deleted')
                            this.$router.push('/help/list')
                        } else {
                            this.$toasted.error('Unable to delete help')
                        }
                    })
            } else {
                this.$toasted.error(`Unable to delete help`)
            }
        },
    },
    created () {
        this.$api.getItem(this, 'help', this.helpId)
            .then((data) => {
                this.title = data['tag']
                this.helpInfo = data
            })
        Authorization.can({ action: 'edit', model: 'help', arg: this.helpId })
            .then((canEdit) => this.canEdit = canEdit)
        Authorization.can({ action: 'delete', model: 'help', arg: this.helpId })
            .then((can) => this.canDelete = can)
    },
})
</script>
